import { useHead } from "./useHead";

export default function SeoOrg() {
    const org = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Жашыл дем",
        "url": "https://jashyl.com/",
        "logo": "https://jashyl.com/og/jashyl.png",
        "sameAs": ["https://www.instagram.com/jashyldem"],
        "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+996706666909",
            "contactType": "customer support",
            "areaServed": "KG",
            "availableLanguage": ["ru", "ky"]
        }],
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "ул. Манаса 41а",
            "addressLocality": "Бишкек",
            "addressCountry": "KG"
        }
    };

    useHead({scripts: [{jsonLD: org}]});
    return null;
}